
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import EarningGraph           from './EarningGraph';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterEarningGraph: actions.enterEarningGraph,
        leaveEarningGraph: actions.leaveEarningGraph
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EarningGraph);



// WEBPACK FOOTER //
// ./src/app/views/earningGraph/index.js